import React, { useCallback } from 'react';
import { useTranslation } from 'next-i18next';

import { Icon, IconButton } from 'components';
import { ButtonV3 } from 'components/ComponentV2';
import { Row } from 'components/layout';
import { signInModalInstance } from 'components/candidate/SignInModal';
import { UserActionEnum } from 'hooks/useOpportunity/useOpportunityInternal';
import { PAGE_ROUTES } from 'lib/page-routes';
import { useOpportunity } from 'lib/providers/OpportunityProvider';

import styles from './ExternalSignupBanner.module.scss';

interface ExternalSignupBannerProps {
  onClose: () => void;
}

export const ExternalSignupBanner: React.FC<ExternalSignupBannerProps> = ({
  onClose,
}) => {
  const [t] = useTranslation('opportunity');
  const [tCommon] = useTranslation('common');
  const { updateUserAction } = useOpportunity();

  const onSignIn = async () => {
    onClose();
    await signInModalInstance();
  };

  const onClickStarted = useCallback(() => {
    updateUserAction({
      userAction: UserActionEnum.REDIRECT_TO,
      userActionURL: PAGE_ROUTES.AI_SEARCH,
    });
  }, []);

  return (
    <section className={styles.container}>
      <IconButton
        size="small"
        iconName="close"
        onClick={onClose}
        className={styles.close}
      />
      <div className={styles.content}>
        <Icon iconName="icon_bolt" size="auto" className={styles.bolt} />
        <p className={styles.title}>{t('external-signup-banner.title')}</p>
        <p className={styles.desc}>{t('external-signup-banner.desc')}</p>
        <ButtonV3
          size="large"
          isFullWidth
          className={styles.signup}
          onClick={onClickStarted}
        >
          {t('external-signup-banner.cta')}
        </ButtonV3>
        <Row align="center" columnGap={2}>
          <p>{tCommon('already-have-account')}</p>
          <ButtonV3
            color="blue"
            variant="text"
            className={styles.signin}
            onClick={onSignIn}
          >
            {tCommon('sign-in')}
          </ButtonV3>
        </Row>
      </div>
    </section>
  );
};
